<mat-card appearance="raised" class="card">
  <mat-card-header class="card-header mat-elevation-z4">
    <mat-card-title class="card-header__title-container">
      <img *ngIf="logoExists" class="logo" [src]="logoSrc" />
      <div *ngIf="!logoExists" class="avatar">
        <mat-icon class="icon">account_balance</mat-icon>
      </div>
      <h2 class="card-header__heading">{{ institution.institutionName }}</h2>
    </mat-card-title>
  </mat-card-header>
  <mat-card-content class="mat-card-content-lg no-bottom-padding">
    <ifc-horizontal-list [items]="listItems">
      <ng-template horizontalListCustomTemplate="linkStatusValue">
        <div class="status-container">
          <ifc-status-label
            [status]="bankLinkStatusLabels"
            [value]="institutionIntegrationStatus"
            [ngClass]="{ clickable: !institution.isLinked }"
            (click)="relink()"
          ></ifc-status-label>
        </div>
      </ng-template>
    </ifc-horizontal-list>
  </mat-card-content>
</mat-card>
